import {useEffect, useState} from 'react';
import {avatarFor} from './supportTeamIdentity';

// SupportAvatar — círculo 28px con iniciales sobre $dark (o la foto del equipo cuando exista).
// name: author_name plano. Se usa en el hilo (mensajes del equipo) y en el saludo del panel.
//
// avatarUrl (opcional): foto de perfil real del admin (Google, `author_avatar_url` del backend).
// Tiene prioridad sobre el mapa estático de fotos. Si la imagen falla al cargar (URL caída,
// permisos), caemos a las iniciales vía el state local `imgError`.
//
// team: el autor es del equipo de Dashbo. Sólo entonces se busca su foto en el mapa estático, que
// matchea por primer nombre (ver `avatarFor`).
export const SupportAvatar = ({name, size, avatarUrl, team = false}) => {
    const {image, initials} = avatarFor(name, {team});
    const [imgError, setImgError] = useState(false);

    // Resetear el estado de error si cambia la URL (reuso del componente entre filas/mensajes).
    useEffect(() => {
        setImgError(false);
    }, [avatarUrl]);

    const style = size ? {width: size, height: size, fontSize: Math.round(size * 0.42)} : undefined;
    // La foto real del admin gana; si no hay o falló, el asset estático del equipo; si tampoco, iniciales.
    const src = (avatarUrl && !imgError) ? avatarUrl : image;
    if (src) {
        return (
            <img
                className="support-chat-avatar"
                style={style}
                src={src}
                alt={name || ''}
                onError={() => setImgError(true)}
            />
        );
    }
    return (
        <span className="support-chat-avatar -initials" style={style} aria-hidden="true">
            {initials}
        </span>
    );
};
